export function formatIsoFromMonthDate(monthDate: Date) {
  return `${monthDate.getFullYear()}-${('0' + (monthDate.getMonth() + 1)).slice(-2)}-${(
    '0' + monthDate.getDate()
  ).slice(-2)}T00:00:00.00Z`;
}
